export default __webpack_public_path__ + "static/media/card-img-2.3290c07f.svg";